import { AxiosProgressEvent, AxiosResponse } from "axios";

import { EAccount } from "types/index";

export enum EMethod {
  "POST" = "POST",
  "PUT" = "PUT",
  "DEL" = "DELETE",
  "GET" = "GET",
  "PATCH" = "PATCH",
}

export type TCallbackUpload = (
  payload: any,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => Promise<AxiosResponse<any, any>>;

export type TOptionData = {
  id: string;
  name: string;
};

export type TPhoneNumber = {
  isdCode: string;
  number: string;
};

export type TAddress = {
  id?: string;
  name: string;
  country: string;
  postalCode: string;
  addressLine1: string;
  addressLine2: string;
  prefecture?: string;
  city: string;
  phoneNumber: TPhoneNumber;
  isDefault: boolean;
};

export type TImageList = {
  id: string;
  profilePicture: string;
  label: string;
  type?: EAccount;
};

type Sort = {
  key: string;
  type: string;
};

export type PaginationReq = {
  page: number;
  pageSize: number;
  keyword?: string;
  sort?: Sort;
  idBusinessUnit?: string;
};

export interface IBasePagination {
  page: number;
  pageSize: number;
  total: number;
}

export interface TRawPagination<T> extends IBasePagination {
  data: T[];
}

export enum EPriority {
  "MOST_IMPORTANT" = "MOST_IMPORTANT",
  "NORMAL" = "NORMAL",
  "IMPORTANT" = "IMPORTANT",
}

export enum EDueStatus {
  "OVERDUE" = "OVERDUE",
  "NOT_OVERDUE" = "NOT_OVERDUE",
}
